import { useParams, Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import { categories, allArticles } from '@/mocks/siteData';

const categoryImageMap: Record<string, string> = {
  'lishi-qiyuan': 'https://readdy.ai/api/search-image?query=Ancient%20Japanese%20scroll%20and%20vintage%20film%20reels%20on%20wooden%20table%2C%20historical%20archival%20atmosphere%2C%20warm%20museum%20lighting%2C%20cultural%20heritage%20photography&width=1200&height=500&seq=cat-hero-hist&orientation=landscape',
  'leixing-fenlei': 'https://readdy.ai/api/search-image?query=Organized%20library%20shelves%20with%20categorized%20Japanese%20art%20books%20and%20catalogs%2C%20academic%20classification%20system%2C%20warm%20reading%20room%20light%2C%20scholarly%20photography&width=1200&height=500&seq=cat-hero-type&orientation=landscape',
  'wenhua-beijing': 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20temple%20gate%20with%20modern%20cityscape%20background%2C%20cultural%20fusion%20concept%2C%20warm%20sunset%20light%2C%20documentary%20photography&width=1200&height=500&seq=cat-hero-cult&orientation=landscape',
  'chanye-fenxi': 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20media%20production%20office%20with%20computers%20and%20creative%20workspace%2C%20clean%20professional%20environment%2C%20soft%20office%20lighting%2C%20corporate%20photography&width=1200&height=500&seq=cat-hero-ind&orientation=landscape',
  'guankan-xuzhi': 'https://readdy.ai/api/search-image?query=Elegant%20home%20library%20with%20reading%20chair%20and%20warm%20lamp%20light%2C%20quiet%20study%20atmosphere%2C%20peaceful%20interior%20design%2C%20lifestyle%20photography&width=1200&height=500&seq=cat-hero-guide&orientation=landscape',
};

const articleImageMap: Record<string, string> = {
  'article-1': 'https://readdy.ai/api/search-image?query=Japanese%20animation%20studio%20workspace%20with%20drawing%20table%20and%20storyboard%20frames%20on%20wall%2C%20warm%20ambient%20lighting%2C%20professional%20anime%20production%20environment%2C%20clean%20and%20organized%2C%20editorial%20photography%20with%20soft%20shadows&width=600&height=375&seq=article-def-01&orientation=landscape',
  'article-2': 'https://readdy.ai/api/search-image?query=Retro%20Japanese%20VHS%20tape%20collection%20displayed%20on%20wooden%20shelves%20with%20vintage%20anime%20artwork%20covers%2C%201980s%20aesthetic%2C%20warm%20nostalgic%20lighting%2C%20cultural%20archival%20photography&width=600&height=375&seq=article-hist-01&orientation=landscape',
  'article-3': 'https://readdy.ai/api/search-image?query=Japanese%20Akihabara%20district%20with%20anime%20posters%20and%20electronics%20stores%2C%20urban%20cultural%20landscape%2C%20warm%20evening%20neon%20glow%2C%20documentary%20style%20photography%20with%20cinematic%20composition&width=600&height=375&seq=article-cult-01&orientation=landscape',
  'article-4': 'https://readdy.ai/api/search-image?query=Professional%20animation%20studio%20interior%20with%20digital%20drawing%20tablets%20and%20color%20scripts%20displayed%2C%20clean%20modern%20workspace%2C%20soft%20diffused%20lighting%2C%20editorial%20photography&width=600&height=375&seq=article-ind-01&orientation=landscape',
  'article-5': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20viewing%20setup%20with%20large%20monitor%20and%20comfortable%20lighting%2C%20clean%20aesthetic%20room%2C%20soft%20warm%20ambient%20light%2C%20editorial%20interior%20photography&width=600&height=375&seq=article-guide-01&orientation=landscape',
  'article-6': 'https://readdy.ai/api/search-image?query=Organized%20library%20of%20categorized%20Japanese%20animation%20art%20books%20on%20wooden%20shelves%2C%20academic%20setting%2C%20warm%20reading%20room%20lighting%2C%20scholarly%20atmosphere%20photography&width=600&height=375&seq=article-type-01&orientation=landscape',
  'article-7': 'https://readdy.ai/api/search-image?query=Modern%20digital%20content%20creation%20workspace%20with%20multiple%20screens%20displaying%20animation%20timeline%2C%20clean%20tech%20office%2C%20cool%20ambient%20lighting%2C%20professional%20technology%20photography&width=600&height=375&seq=article-dig-01&orientation=landscape',
  'article-8': 'https://readdy.ai/api/search-image?query=Japanese%20government%20building%20exterior%20with%20cherry%20blossom%20trees%2C%20formal%20institutional%20architecture%2C%20clear%20daylight%2C%20documentary%20architectural%20photography&width=600&height=375&seq=article-law-01&orientation=landscape',
  'article-9': 'https://readdy.ai/api/search-image?query=Calm%20and%20serene%20meditation%20space%20with%20soft%20natural%20light%20streaming%20through%20window%2C%20minimalist%20interior%20with%20plants%2C%20peaceful%20wellness%20atmosphere%2C%20editorial%20photography&width=600&height=375&seq=article-psy-01&orientation=landscape',
  'article-10': 'https://readdy.ai/api/search-image?query=Evolution%20of%20media%20formats%20displayed%20chronologically%20from%20VHS%20to%20Blu-ray%20to%20streaming%20icon%2C%20clean%20museum-style%20exhibition%2C%20soft%20gallery%20lighting%2C%20educational%20display%20photography&width=600&height=375&seq=article-media-01&orientation=landscape',
  'article-11': 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20animation%20style%20boards%20on%20studio%20wall%2C%20professional%20art%20direction%20setting%2C%20clean%20studio%20lighting%2C%20editorial%20photography&width=600&height=375&seq=article-comp-01&orientation=landscape',
  'article-12': 'https://readdy.ai/api/search-image?query=International%20shipping%20and%20trade%20concept%20with%20world%20map%20and%20cultural%20exchange%20icons%2C%20clean%20corporate%20style%2C%20professional%20business%20photography%20with%20warm%20lighting&width=600&height=375&seq=article-glob-01&orientation=landscape',
  'article-13': 'https://readdy.ai/api/search-image?query=Official%20document%20and%20regulation%20books%20stacked%20on%20desk%20with%20reading%20lamp%2C%20legal%20research%20setting%2C%20warm%20library%20lighting%2C%20scholarly%20photography&width=600&height=375&seq=article-censor-01&orientation=landscape',
  'article-14': 'https://readdy.ai/api/search-image?query=Person%20reading%20and%20taking%20notes%20at%20a%20clean%20modern%20desk%20with%20laptop%2C%20educational%20self-improvement%20setting%2C%20soft%20natural%20light%2C%20editorial%20lifestyle%20photography&width=600&height=375&seq=article-lit-01&orientation=landscape',
};

export default function CategoryPage() {
  const { categorySlug } = useParams<{ categorySlug: string }>();
  const category = categories.find((c) => c.slug === categorySlug);

  if (!category) {
    return (
      <Layout>
        <div className="py-20 text-center">
          <i className="ri-error-warning-line text-4xl text-foreground-300 mb-4 block"></i>
          <h1 className="font-heading text-xl font-bold text-foreground-900 mb-2">分类未找到</h1>
          <Link to="/categories" className="text-primary-600 hover:text-primary-700 text-sm">返回分类浏览</Link>
        </div>
      </Layout>
    );
  }

  const articles = allArticles.filter((a) => a.categoryId === categorySlug);

  return (
    <Layout>
      <SEOHead
        title={`${category.name} · 日本里番${category.name}研究文章`}
        description={category.description}
        keywords={`日本里番${category.name},${category.name}分类,里番${category.name}研究`}
        canonicalUrl={`https://example.com/categories/${categorySlug}`}
      />

      <section className="relative w-full h-[300px] md:h-[360px] overflow-hidden">
        <img
          src={categoryImageMap[category.slug]}
          alt={category.name}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <div className="text-center max-w-2xl">
            <div className="w-14 h-14 rounded-xl bg-background-50/20 backdrop-blur-sm flex items-center justify-center mx-auto mb-4">
              <i className={`${category.icon} text-2xl text-background-50`}></i>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
              {category.name}
            </h1>
            <p className="text-background-100/80 text-sm md:text-base max-w-xl mx-auto">
              {category.description}
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: '分类浏览', to: '/categories' },
              { label: category.name },
            ]}
          />

          <div className="mb-8">
            <h2 className="font-heading text-xl font-bold text-foreground-900 mb-2">
              共 {articles.length} 篇研究文章
            </h2>
          </div>

          <div className="space-y-5">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.slug}`}
                className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-200/70 transition-all duration-300"
              >
                <div className="sm:w-48 flex-shrink-0 rounded-md overflow-hidden aspect-[16/10] sm:aspect-auto">
                  <img
                    src={articleImageMap[article.id]}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs text-primary-600 bg-primary-100 px-2.5 py-1 rounded-full">
                      {article.categoryName}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/70">
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4">浏览其他分类</h3>
            <div className="flex flex-wrap gap-3">
              {categories.filter((c) => c.slug !== categorySlug).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/categories/${cat.slug}`}
                  className="px-4 py-2 bg-background-100 text-foreground-600 rounded-full text-sm hover:bg-background-200 hover:text-foreground-800 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}